import { render, staticRenderFns } from "./send-notification.vue?vue&type=template&id=1aa5b2cc"
import script from "./send-notification.vue?vue&type=script&lang=js"
export * from "./send-notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports